import { useEffect, useMemo, useState } from "react";

import { whatsappService } from "../../../services/whatsapp.service";

export const connectionServesLead = (connection, { accountId }) =>
  accountId != null && Number(connection?.account) === Number(accountId);

export function useWhatsAppAvailability({ accountId = null, responsibleId = null, enabled = true }) {
  const [connections, setConnections] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let mounted = true;
    const load = async () => {
      let results = [];
      try {
        const response = await whatsappService.listAccounts();
        results = Array.isArray(response?.results) ? response.results : [];
      } catch (requestError) {
        results = [];
      }
      if (mounted) setConnections(results);
    };
    load();
    return () => {
      mounted = false;
    };
  }, [enabled]);

  const available = useMemo(
    () =>
      (connections || []).some((connection) =>
        connectionServesLead(connection, { accountId, responsibleId }),
      ),
    [connections, accountId, responsibleId],
  );

  return { available, loading: enabled && connections === null };
}

export default useWhatsAppAvailability;
